export default __webpack_public_path__ + "img/your_events-3cc00473b9a8853ff1f3c7d0189caec1.png";